import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TableSortDownIcon = createIcon({
    viewBox: '0 0 20 20',
    path: <Path d='M10.5 14L16 8H5L10.5 14Z' fill='currentColor' />,
})

TableSortDownIcon.displayName = 'TableSortDownIcon'
